import React from "react"

export default function H1({ text }) {
  return <h1 className=" font-bold inline-block text-white ">{text}</h1>
}
